import { render, staticRenderFns } from "./SkribbleFormRisk.vue?vue&type=template&id=1b321818&scoped=true&"
import script from "./SkribbleFormRisk.vue?vue&type=script&lang=js&"
export * from "./SkribbleFormRisk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b321818",
  null
  
)

export default component.exports